import type { ChartIndicator, CompetitorChartSeries, ShareType } from '../../types';

export const INDICATOR_CPI_BAND_ID = 'cpi-band';
export const INDICATOR_OPTIMAL_BAND_ID = 'optimal-band';
export const INDICATOR_CPI_LINE_ID = 'cpi-line';
export const INDICATOR_OPTIMAL_LINE_ID = 'optimal-line';

export const INDICATOR_BAND_IDS = [INDICATOR_CPI_BAND_ID, INDICATOR_OPTIMAL_BAND_ID] as const;
export const INDICATOR_LINE_IDS = [INDICATOR_CPI_LINE_ID, INDICATOR_OPTIMAL_LINE_ID] as const;

export type IndicatorBandId = (typeof INDICATOR_BAND_IDS)[number];
export type IndicatorLineId = (typeof INDICATOR_LINE_IDS)[number];

export type IndicatorBandConfig = {
  id: IndicatorBandId;
  lineId: IndicatorLineId;
  x: number;
  color: string;
  lineColor: string;
  dashArray: string;
};

export type ChartSeriesContext = {
  volumeSeries: import('../../types').ChartSeries;
  valueSeries: import('../../types').ChartSeries;
  volumeLineData: import('../../types').ChartPoint[];
  valueLineData: import('../../types').ChartPoint[];
  shareVolumeData: import('../../types').ChartPoint[];
  shareValueData: import('../../types').ChartPoint[];
  competitorSeries: CompetitorChartSeries[];
};

export type ChartIndicatorsContext = {
  cpiIndicator?: ChartIndicator;
  optimalIndicator?: ChartIndicator;
  indicatorBandConfigs: IndicatorBandConfig[];
};

export type IndicatorScatterSeriesConfig = {
  indicator?: ChartIndicator;
  fallbackName: string;
  color: string;
  point?: { x: number; y: number | null } | null;
  legendIndex?: number;
  /** `client` do response `/curves` (ElasticityCurveApiResponse). */
  curvesClient?: string | null;
};

export type ChartOptionsContext = {
  chartData: import('../../types').ChartConfig;
  insights: import('../../types').MarketShareInsights;
  seriesContext: ChartSeriesContext;
  indicatorsContext: ChartIndicatorsContext;
  currentUsesSeriesColor: boolean;
  optimalUsesSeriesColor: boolean;
  curvesClient?: string | null;
  competitorDisplayMode?: ShareType | null;
  shouldTruncateCompetitorLegendNames?: boolean;
};
